import React, { useCallback } from 'react';
import * as slice from "../../store/gradingModel/gradingModelSlice";
import { useAppDispatch, useAppSelector } from "../../store/hook";
import { gradeActions } from '../../store/gradingModel/gradingModelSlice';

export const useGrade = () => {
    const dispatch = useAppDispatch();
    return {
        loadGrades: useCallback((payload) => {
            dispatch(gradeActions.loadGrade(payload));
        }, [dispatch]),
        loadCurrent: useCallback((payload) => {
            dispatch(gradeActions.loadCurrentGrade(payload));
        }, [dispatch]),
        save: useCallback((payload) => {
            dispatch(gradeActions.saveCurrentGrade(payload));
        }, [dispatch]),
        create: useCallback((payload) => {
            dispatch(gradeActions.createGrade(payload));
        }, [dispatch]),
        remove: useCallback((payload) => {
            dispatch(gradeActions.removeGrade(payload));
        }, [dispatch]),
        setGradingModelList: useCallback((payload) => {
            dispatch(gradeActions.setGradingModelList(payload));
        }, [dispatch]),


        gradeList: useAppSelector(slice.getGrade),
        current: useAppSelector(slice.getCurrentGrade),
        loading: useAppSelector(slice.isLoading),
        pagination: useAppSelector(slice.getPagination),
        gradingModelList: useAppSelector(slice.getGradingModelList),
    }
}